import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // Récupérer l'URL complète actuelle depuis window.location
    // Plus fiable que router.url pour les guards sur routes lazy-loaded
    const fullPath = window.location.pathname.slice(1); // Enlever le slash initial

    // Permettre l'accès aux routes de partage même si connecté
    // (scrap = site vitrine public /scrap/{slug}, visible aussi en preview
    // par un visiteur connecté au BO)
    if (fullPath.startsWith('share') || fullPath.startsWith('share/') ||
        fullPath.startsWith('base') || fullPath.startsWith('base/') ||
        fullPath.startsWith('scrap') || fullPath.startsWith('scrap/')) {
      return true;
    }

    // Pour les autres routes publiques (login, register...), rediriger si connecté
    if (localStorage.getItem('access_token')) {
      this.router.navigate(['/chat']);
      return false; // Si l'utilisateur est connecté, redirige vers le tableau de bord
    } else {
      return true;
    }
  }
}
